export default "__VITE_ASSET__CGbTADzb__"